function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M1144.94 114.374c270.49 132.541-86.81 326.425-645.678 567.043C57.278 887.577-94.69 348.472 59.803 180.758S874.449-18.166 1144.94 114.374z",
  fill: "#BE81CB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1077.03 34.255c279.91 95.895-39.36 334.684-547.298 646.133C130.192 942.415-90.643 428.309 35.926 241.975 162.495 55.641 797.115-61.64 1077.03 34.255z",
  fill: "url(#skills-backdrop_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "skills-backdrop_svg__paint0_linear",
  x1: 590.667,
  y1: 0.04,
  x2: 590.667,
  y2: 753.324,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#864BD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BE81CB"
})));

function SvgSkillsBackdrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1238 754",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIzOCA3NTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMSIgZD0iTTExNDQuOTQgMTE0LjM3NEMxNDE1LjQzIDI0Ni45MTUgMTA1OC4xMyA0NDAuNzk5IDQ5OS4yNjIgNjgxLjQxN0M1Ny4yNzgxIDg4Ny41NzcgLTk0LjY4OTkgMzQ4LjQ3MiA1OS44MDMgMTgwLjc1OEMyMTQuMjk2IDEzLjA0MzkgODc0LjQ0OSAtMTguMTY2NSAxMTQ0Ljk0IDExNC4zNzRaIiBmaWxsPSIjQkU4MUNCIi8+CjxwYXRoIGQ9Ik0xMDc3LjAzIDM0LjI1NUMxMzU2Ljk0IDEzMC4xNSAxMDM3LjY3IDM2OC45MzkgNTI5LjczMiA2ODAuMzg4QzEzMC4xOTIgOTQyLjQxNSAtOTAuNjQzNCA0MjguMzA5IDM1LjkyNjEgMjQxLjk3NUMxNjIuNDk1IDU1LjY0MDYgNzk3LjExNSAtNjEuNjM5OSAxMDc3LjAzIDM0LjI1NVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjU5MC42NjciIHkxPSIwLjA0MDI4MzIiIHgyPSI1OTAuNjY3IiB5Mj0iNzUzLjMyNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjODY0QkQwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0JFODFDQiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgSkillsBackdrop as ReactComponent };